module.exports = __webpack_public_path__ + "img/pulse1.adde5cc3.jpg";